var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "modal__content-title" }, [
      _c("span", {
        staticClass: "modal__item-title",
        domProps: { innerHTML: _vm._s(_vm.item.title) }
      }),
      _vm._v(" "),
      _vm.item.description
        ? _c("div", {
            staticClass: "modal__item-details",
            domProps: { innerHTML: _vm._s(_vm.item.description) }
          })
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "grid modal__wo-meta-data" }, [
      _c(
        "div",
        { staticClass: "grid__col-no-gutter--4 h-no-padding" },
        [
          _c("People", { attrs: { item: _vm.item } }),
          _vm._v(" "),
          _c("FileAttachments", { attrs: { item: _vm.item } })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "grid__col--8" }, [
        _c("div", { staticClass: "modal__item-row" }, [
          _vm.item.note
            ? _c("div", { staticClass: "grid modal__wo-note-container" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("div", {
                  staticClass:
                    "grid__col--11 h-no-margin h-no-padding modal__wo-note",
                  domProps: { innerHTML: _vm._s(_vm.item.note) }
                })
              ])
            : _vm._e()
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "grid__col--1 h-no-padding h-right-align" },
      [_c("i", { staticClass: "fas fa-sticky-note h-color-fuel-navy" })]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }